<div
  class="w-full border-solid border-[thin] rounded-xl flex items-center gap-2 p-3 transition-all ease-in-out duration-300 cursor-pointer"
  (click)="toggleSelect($event)"
  [ngClass]="{
    'border-color-primary bg-color-surface': isSelected(),
    'border-color-blue-90 bg-[#FFFFFF]': !isSelected(),
  }"
>
  <div
    class="w-8 h-8 flex-none rounded-full flex items-center justify-center transition-all ease-in-out duration-300"
    [ngClass]="{
      'bg-color-surface': !isSelected(),
      'bg-[#FFFFFF]': isSelected(),
    }"
  >
    @if (item.imageUrl) {
      <img [src]="item.imageUrl" alt="tree item image" class="w-full h-full rounded-full object-cover" />
    }
    @if (!item.imageUrl) {
      <mat-icon class="max-h-4 h-4 max-w-4 w-4 text-[16px] text-color-primary rounded-full">
        {{ item.icon }}
      </mat-icon>
    }
  </div>

  <div class="w-full grow flex flex-row items-center gap-2">
    <p class="text-color-neutral text-sm m-0 p-0 break-all">
      {{ item.name }}
    </p>

    <div class="flex-none flex flex-row items-center">
      @if (item.hasOnlyMaintenanceInProgress || (!isOpened() && item.hasMaintenanceInProgress)) {
        <div class="flex flex-row items-center gap-1 px-[10px] py-[4px] rounded-full bg-color-warning bg-opacity-10">
          <div class="w-2 h-2 rounded-full bg-color-warning"></div>
          <p class="p-0 m-0 text-color-warning font-medium text-xs">
            {{ 'ASSETS_TREE.TREE_SECTION.TREE_VIEW.IN_PROGRESS_MAINTENANCE' | translate }}
          </p>
        </div>
      }
      @if (item.archived) {
        <div class="flex flex-row items-center gap-1 px-[10px] py-[4px] rounded-full bg-color-old-gray-50 bg-opacity-10">
          <div class="w-2 h-2 rounded-full bg-color-old-gray-50"></div>
          <p class="p-0 m-0 text-color-old-gray-50 font-medium text-xs">
            {{ 'ASSETS_TREE.TREE_SECTION.TREE_VIEW.ARCHIVED' | translate }}
          </p>
        </div>
      }
    </div>
  </div>

  @if (item.original?.warrantySummary?.status) {
    <app-warranty-status-label
      [status]="item.original?.warrantySummary?.status"
      [extendedTranslate]="true"
      [isHovering]="isSelected()"
    ></app-warranty-status-label>
  }

  @if (showArrowButton()) {
    <button
      type="button"
      class="w-8 h-8 flex-none cursor-pointer bg-[#FFFFFF] rounded-xl flex items-center justify-center border-[thin] border-solid border-color-blue-90"
      (click)="toggleShowChildren($event)"
    >
      <mat-icon
        class="max-h-4 h-4 max-w-4 w-4 text-[16px] text-color-primary transition-all ease-in-out duration-300"
        [ngClass]="{ 'rotate-180': isOpened() }"
      >
        expand_more
      </mat-icon>
    </button>
  }
</div>

@if (isOpened()) {
  <div>
    @if (showArrowButton() && isLoading()) {
      <div [@fadeInOut] class="flex flex-col justify-center items-center mt-3">
        <mat-spinner diameter="24" color="primary"></mat-spinner>
      </div>
    }
    @if (!isLoading() && children().length) {
      <div [@listAnimation]="children().length" class="flex flex-col w-full pl-7 mt-3">
        @for (child of children(); track $index; let isLast = $last) {
          <div class="w-full flex flex-row">
            <div class="w-full flex flex-row gap-1">
              <div class="w-6 h-full flex flex-col items-stretch">
                <div class="flex-none w-full h-7 border border-solid border-color-blue-90 border-r-0 border-t-0 rounded-bl-lg"></div>
                @if (!isLast) {
                  <div class="w-full grow border border-solid border-color-blue-90 border-y-0 border-r-0"></div>
                }
              </div>
              <tree-view [item]="child" [level]="level + 1" class="w-full"></tree-view>
            </div>
          </div>
          @if (!isLast) {
            <div class="w-full h-3 border border-solid border-color-blue-90 border-y-0 border-r-0"></div>
          }
        }
      </div>
    }
  </div>
}
